import type { Discount } from "../../api/types";
import { t } from "../../i18n";
import { discountLabel } from "../general/general";

interface Props {
  /** The discounts the shop chose in Beheer › Algemeen. */
  discounts: readonly Discount[];
  chosen: Discount | null;
  onChoose: (discount: Discount | null) => void;
}

/** The "Korting" buttons ("−4", "−10%", …) and "Geen": at the checkout and while editing an order. */
export function DiscountButtons({ discounts, chosen, onChoose }: Props) {
  return (
    <div className="disc">
      {discounts.map((discount) => (
        <button
          key={discountLabel(discount)}
          type="button"
          aria-pressed={JSON.stringify(chosen) === JSON.stringify(discount)}
          onClick={() => {
            onChoose(discount);
          }}
        >
          {discountLabel(discount)}
        </button>
      ))}
      <button
        type="button"
        className="nodisc"
        aria-pressed={chosen === null}
        onClick={() => {
          onChoose(null);
        }}
      >
        {t.checkout.noDiscount}
      </button>
    </div>
  );
}
